import washokuLogo from '@/assets/logo9.svg';
import popsupLogo from '@/assets/popsuplogo.svg';
import popsupFavIcon from '@/assets/popsupicon.svg';
import washoluFavIcon from '@/assets/logo1.svg';
import { TermsAndConditions, TermsAndConditionsOfPOPSUP } from '@/constants/TermsAndConditionText';
import { PrivacyPolicy, PrivacyPolicyOfPOPSUP } from '@/constants/PrivacyPolicyText';

export default {
  dev: {
    longLogo: popsupLogo,
    logoText: 'POPSUP Global',
    copyRightText: 'POPSUP Global - All Rights Reserved',
    favicon: popsupFavIcon,
    title: 'Popsup Global',
    link: 'https://www.popsup.global',
    terms: TermsAndConditionsOfPOPSUP,
    privacy: PrivacyPolicyOfPOPSUP,
  },
  prod: {
    longLogo: popsupLogo,
    logoText: 'POPSUP Global',
    copyRightText: 'POPSUP Global - All Rights Reserved',
    favicon: popsupFavIcon,
    title: 'Popsup Global',
    link: 'https://www.popsup.global',
    terms: TermsAndConditionsOfPOPSUP,
    privacy: PrivacyPolicyOfPOPSUP,
  },
};
